import React, { useEffect, useState } from "react";
import EditView from "./EditView";
import TemplateView from "./TemplateView";
import { Grid } from "@mui/material";

export default function OptimiseView() {
  const [selectedSummaries, setSelectedSummaries] = useState([]);
  const [addedSkills, setAddedSkills] = useState([]);
  const [responsibilities, setResponsibilities] = useState([]);

  // useEffect(() => {
  //   console.log(
  //     "selected summary optimise view-----------------------",
  //     selectedSummaries
  //   );
  // }, [selectedSummaries]);

  // useEffect(() => {
  //   console.log("Selected Skills:", addedSkills);
  // }, [addedSkills]);

  useEffect(() => {
    console.log("Selected responsibilities:", responsibilities);
  }, [responsibilities]);

  return (
    <Grid container spacing={0} sx={{ width: "100%", m: 0, p: 0 }}>
      <Grid item xs={6}>
        <EditView
          setSelectedSummaries={setSelectedSummaries}
          setAddedSkills={setAddedSkills}
          setResponsibilities={setResponsibilities}
        />
      </Grid>
      <Grid item xs={6}>
        <TemplateView
          selectedSummaries={selectedSummaries}
          addedSkills={addedSkills}
          responsibilities={responsibilities}
        />
      </Grid>
    </Grid>
  );
}
